import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import * as validators from 'utils/validators';
import Dialog from 'components/Dialog';
import DateTimeField from 'components/DateTimeField';
import ShopifyLocationsSelectField from 'components/ShopifyLocationsField';
import ThemeGallery from 'components/ThemeGallery';
import TemplateMarketDialog from 'containers/TemplateMarketDialog';
import * as billing from 'modules/billing';
import { canUseFeature } from '../../../config/pricing';

class DownloadInvoicesDialog extends Dialog {
    getThemeByName(themes, name) {
        for (var i = 0; themes && i < themes.length; i++) {
            if (themes[i].name === name) {
                return themes[i];
            }
        }

        return {};
    }

    render() {
        const { handleSubmit, submitting, closeButtonLabel, what, format, user, theme, dispatch, initialValues, created_at_min, created_at_max, intl } = this.props;
        const t = (id, values) => intl.formatMessage({ id }, values);
        let type = (this.getThemeByName(user.themes, theme).documentType || "invoice") + "s";

        const show = this.state.show;
        const country = user.accounting ? user.accounting.country : '';


        return (

            <Modal backdrop="static" dialogClassName="download-orders-dialog" enforceFocus={true} show={show || false} onHide={this.hide}>
                <form /*onSubmit={handleSubmit(this.props.onOk)}*/>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('downloadDialog.downloadType', { type: type[0].toUpperCase() + type.substring(1) })}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ overflowY: 'visible' }}>
                        <p>{t('downloadDialog.selectTemplate')}</p>
                        <div>
                            <Field name="theme" selectedTheme={theme} seller={user} themes={user.themes} component={ThemeGallery}></Field>
                            <TemplateMarketDialog onOk={(theme) => {
                                dispatch(billing.installTheme(theme))
                            }} ref={(i) => this._templateMarketDialog = i} />
                            {/* <a className="pull-right" onClick={() => {
                                this._templateMarketDialog.wrappedInstance.wrappedInstance.show();
                            }} title="Install Templates from Market"><i className="widget-add-item fa fa-shopping-cart" ></i>{" "}Get more Templates</a>
                            <a className="pull-right" href="/templates" target="_blank" title="Create a new Template"><i className="widget-add-item fa fa-pencil" ></i>{" "}Create a new Template</a> */}


                            {theme && theme.length > 0 && <label>

                                <Field name="what" component="input" type="radio" value="all" /> {t('downloadDialog.allCreatedBetween', { type })}
                            </label>}{"    "}
                            {theme && theme.length > 0 && !user.hasMultipleLocations && <label><Field name="what" component="input" type="radio" value="selected" /> {t('downloadDialog.selectedType', { type })}
                            </label>}
                            {what === 'all' &&
                                <div className="row">
                                    <div className="col-md-5">
                                        <Field
                                            name="created_at_min"
                                            component={DateTimeField}
                                            validate={[validators.required]}
                                            defaultValue={new Date(created_at_min) || new Date(initialValues.created_at_min)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label>{" " + t('downloadDialog.and') + " "}</label>
                                    </div>
                                    <div className="col-md-5">
                                        <Field
                                            name="created_at_max"
                                            component={DateTimeField}
                                            defaultValue={new Date(created_at_max) || new Date(initialValues.created_at_max)}
                                            validate={[validators.required]}
                                        />
                                    </div>
                                </div>}
                            {what === 'all' &&
                                theme && theme.length > 0 && <div className="row">
                                    <br />
                                    <div className="col-md-4">

                                        <label>{t('downloadDialog.status')}</label>{" "}
                                        <Field className="form-control" name="status" component="select">
                                            <option value="any">{t('downloadDialog.any')}</option>
                                            <option value="open">{t('downloadDialog.open')}</option>
                                            <option value="closed">{t('downloadDialog.closed')}</option>
                                            <option value="cancelled">{t('downloadDialog.cancelled')}</option>

                                        </Field>

                                    </div>
                                    <div className="col-md-4">
                                        <label>{t('downloadDialog.paymentStatus')}</label>{" "}
                                        <Field className="form-control" name="financial_status" component="select">
                                            <option value="any">{t('downloadDialog.any')}</option>
                                            <option value="authorized">{t('downloadDialog.authorized')}</option>
                                            <option value="pending">{t('downloadDialog.pending')}</option>
                                            <option value="paid">{t('downloadDialog.paid')}</option>
                                            <option value="partially_paid">{t('downloadDialog.partiallyPaid')}</option>
                                            <option value="refunded">{t('downloadDialog.refunded')}</option>
                                            <option value="voided">{t('downloadDialog.voided')}</option>
                                            <option value="partially_refunded">{t('downloadDialog.partiallyRefunded')}</option>
                                            <option value="unpaid">{t('downloadDialog.unpaid')}</option>
                                        </Field>

                                    </div>
                                    <div className="col-md-4">

                                        <label>{t('downloadDialog.fulfillmentStatus')}</label>{" "}
                                        <Field className="form-control" name="fulfillment_status" component="select">
                                            <option value="any">{t('downloadDialog.any')}</option>
                                            <option value="shipped">{t('downloadDialog.fulfilled')}</option>
                                            <option value="partial">{t('downloadDialog.partial')}</option>
                                            <option value="unshipped">{t('downloadDialog.unfulfilled')}</option>
                                        </Field>


                                    </div>
                                </div>
                            }
                            <br />

                            {what === 'all' && user.hasMultipleLocations && <div className="row">
                                <div className="col-md-2">
                                    <label htmlFor="locationId">{t('downloadDialog.forLocation')}</label>
                                    <Field id="locationId" name="locationId" component={ShopifyLocationsSelectField} download={true} validate={[validators.required]} />
                                </div>
                            </div>
                            }

                            {theme && theme.length > 0 && <div className="row">
                                <div className="col-md-12">
                                    <label>{t('downloadDialog.format')}</label>{" "}
                                    <label><Field name="format" className="export-as-pdf-radio" component="input" type="radio" value="pdf" />{" "}PDF</label>{" "}
                                    {/* <label><Field name="format" component="input" type="radio" value="zip" />{" "}Zip</label>{" "} */}
                                    {user.profile && canUseFeature(user.profile.subscription, 'bulkExportExcel') && <label><Field name="format" component="input" type="radio" value="xlsx" />{" "}Excel</label>}{" "}
                                    {user.profile && canUseFeature(user.profile.subscription, 'bulkExportExcel') && <label><Field name="format" component="input" type="radio" value="sagaxml" />{" "}SAGA Ro Xml</label>}{" "}
                                    {user.profile && canUseFeature(user.profile.subscription, 'ublXml') && <label><Field name="format" component="input" type="radio" value="ublxml" />{" "}UBL Invoice Xml / E-Factura</label>}{" "}
                                    {user.profile && canUseFeature(user.profile.subscription, 'ublXml') && <label><Field name="format" component="input" type="radio" value="zugferd" />{" "}ZUGFeRD / Factur-X</label>}
                                    {user.profile && !canUseFeature(user.profile.subscription, 'ublXml') && <label style={{color:'#999', cursor:'not-allowed'}} title="Upgrade to Starter plan to unlock UBL/XML exports"><span style={{opacity:0.5}}>Peppol UBL Invoice Xml / E-Factura</span> <span className="label label-info">Starter</span></label>}
                                    {user.profile && !canUseFeature(user.profile.subscription, 'bulkExportExcel') && <label style={{color:'#999', cursor:'not-allowed'}} title="Upgrade to a paid plan to unlock Excel and XML exports"><span style={{opacity:0.5}}>Excel / Peppol XML</span> <span className="label label-default">Paid plans</span></label>}
                                </div>
                            </div>}

                            {format === "xlsx" &&
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="panel panel-default">
                                            <div className="panel-heading">
                                                {t('downloadDialog.advancedOptions')}
                                    </div>
                                            <div className="panel-body">
                                                <div className="checkbox">
                                                    <label htmlFor="exportHSCodes">
                                                        <Field value="exportHSCodes" id="exportHSCodes" name="exportHSCodes" component="input" type="checkbox" />{t('downloadDialog.exportHSCodes')}</label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            }


                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <small className="pull-left">{t('downloadDialog.noteChrome')}</small><br />
                        <Button type="button" onClick={this.hide}>{closeButtonLabel}</Button>
                        <Button type="button" onClick={handleSubmit(values=> {
                                values.individually = true;
                                this.props.onOk(values)
                            }
                        )} disabled={!theme} className="export-download-button" bsStyle="default">{t('downloadDialog.downloadIndividually')}</Button>
                        <Button type="button" onClick={handleSubmit(values=> {
                                values.individually = false;
                                this.props.onOk(values)
                            }
                        )} disabled={!theme} className="export-download-button" bsStyle="success">{t('downloadDialog.downloadGrouped')}</Button>
                    </Modal.Footer>

                </form>
            </Modal>

        );
    }
}


DownloadInvoicesDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    closeButtonLabel: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired
}

let DownloadInvoicesDialogForm = reduxForm({ form: "DownloadInvoicesDialog" })(DownloadInvoicesDialog);

const selector = formValueSelector('DownloadInvoicesDialog');

DownloadInvoicesDialogForm = connect(state => {
    const what = selector(state, 'what');
    const type = selector(state, 'type');
    const format = selector(state, 'format');
    const theme = selector(state, 'theme');
    const created_at_min = selector(state, 'created_at_min');
    const created_at_max = selector(state, 'created_at_max');
    return {
        what,
        type,
        theme,
        format,
        created_at_min,
        created_at_max
    }
}, null, null, {
    withRef: true
})(DownloadInvoicesDialogForm);

export default DownloadInvoicesDialogForm;



// WEBPACK FOOTER //
// app/components/dashboard/DownloadInvoicesDialog.jsx